import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { INAAction } from '../../model/ina-action';
import { Section } from '../model/inaSchoolEnrollments';
import { Shared } from '../../service/shared';
import { InaService } from '../../service/ina.service';
import { RelationToChild } from '../../model/relation-To-Child';
import { StepAction } from '../model/stepAction';
import { TrackingHistories, TrackingHistory } from '../../service/history';

@Component({
  selector: 'app-parent-guardian-information',
  templateUrl: './parent-guardian-information.component.html',
  styleUrls: ['./parent-guardian-information.component.scss']
})


export class ParentGuardianInformationComponent implements OnInit {
  @Input('step') step: number;
  @Input('action') action: INAAction;

  @Output() prevOrNextStep = new EventEmitter<StepAction>();
  @Output() updateHistory =new EventEmitter<TrackingHistory>();
  
  frmParentGuardian: UntypedFormGroup;
  section: Section;
  shared: Shared;
  inaStatusTypeId: number;

  notifyAction: string = '';
  relationShipData: RelationToChild[] = [];
  lstTrackHistory: TrackingHistory[] = [];
  trackHistories: TrackingHistories = new TrackingHistories();


  constructor(
    private fb: UntypedFormBuilder, 
    private inaService: InaService
  ) {
    this.shared = new Shared(inaService);
    this.trackHistories.inaHistory = [];
    this.relationShipData = this.shared.getRelationships();
    this.frmParentGuardian = this.fb.group({
      currentParent1: [],
      relationship1: [],
      phone1: [],
      currentParent2: [],
      relationship2: [],
      phone2: [],
    });
  }
  ngOnInit(): void {
    let sectionId: number = 19;
    this.inaService.inaSelectionSubject$.subscribe(x => {
      this.section = x.inaSchoolEnrollment.Sections.find(x => x.SectionID == sectionId)!;
      this.inaStatusTypeId = x.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId;
      if (!this.frmParentGuardian.dirty) {
        this.frmParentGuardian.reset();
        this.setFormValue();  
      }
    });

    setTimeout(() => {
      this.setFormValue();
    }, 1000);
    
    this.inaService.inaHistorySelectionSubject$.subscribe((x: TrackingHistories) => {
      if (x.inaHistory?.length >= 1) {
        this.trackHistories.inaHistory = x.inaHistory.filter(x => x.ChangedField.split(',')[0] == sectionId.toString());
      }

    });


    if (this.action == INAAction.View) {
      this.frmParentGuardian.disable();
    }
    else {
      this.currentParent1.disable();
      this.currentParent2.disable();
      this.frmParentGuardian.valueChanges.subscribe(() => {
        this.updateChangeValue();
      });
    }

  }


  setFormValue() {
    this.currentParent1.setValue(this.getQuestionValue(318, 'Current Parent/Guardian 1'));
    this.relationship1.setValue(this.getQuestionValue(319, 'Relationship 1'));
    this.phone1.setValue(this.getQuestionValue(320, 'Phone 1'));
    this.currentParent2.setValue(this.getQuestionValue(321, 'Current Parent/Guardian 2'));
    this.relationship2.setValue(this.getQuestionValue(322, 'Relationship 2'));
    this.phone2.setValue(this.getQuestionValue(323, 'Phone 2'));
  }

  getQuestionValue(questionId: number, questionName: string): string {
    let retVal: string = this.shared.getQuestionValue(this.section, questionId, questionName);
    return retVal;
  }

  /*
  setStep(index: number) {
    this.step = index;
    let s: StepAction = new StepAction();
    s.stepNumber = this.step;
    this.prevOrNextStep.emit(s);
  }
  
  nextStep() {
    this.notifyAction = 'Next';
    this.notifyChanges(0);
  }

  prevStep() {
    this.notifyAction = 'Prev';
    this.notifyChanges(0);
  }

  notifyChanges(action:number) {
      let s: StepAction = new StepAction();
      s.stepNumber = 2;
      s.action = action == 1 ? '': this.notifyAction ;
      s.section = new Section();
      if (this.frmParentGuardian.dirty) {
        this.updateChangeValue();
        s.section = this.section;
        s.lsttrackingHistory=this.lstTrackHistory;
        this.lstTrackHistory=[];
        this.prevOrNextStep.emit(s);
      }
      this.prevOrNextStep.emit(s);
    
  }*/

  updateChangeValueLostFocus()
  {
    if (this.currentParent1.dirty) {
      this.setListQuestionValue(318, 'Current Parent/Guardian 1', this.currentParent1.value);
      this.currentParent1.markAsPristine();
    }
    if (this.phone1.dirty && this.phone1.valid) {
      this.setListQuestionValue(320, 'Phone 1', this.phone1.value);
      this.phone1.markAsPristine();
    }    
    if (this.currentParent2.dirty) {
      this.setListQuestionValue(321, 'Current Parent/Guardian 2', this.phone1.value);
      this.currentParent2.markAsPristine();
    }    
    if (this.phone2.dirty && this.phone2.valid) {
      this.setListQuestionValue(323, 'Phone 2', this.phone2.value);
      this.phone2.markAsPristine();
    }    
  }      
  updateChangeValue() {

    if (this.relationship1.dirty) {
      this.setListQuestionValue(319, 'Relationship 1', this.relationship1.value);
      this.relationship1.markAsPristine();
    }
    if (this.relationship2.dirty) {
      this.setListQuestionValue(322, 'Relationship 2', this.relationship2.value);
      this.relationship2.markAsPristine();
    }

  }

  setRadioValue(questionId: number, questionName: string, value: string) {
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setRadioValue(this.section, questionId, value);
    
  }

  setListQuestionValue(questionId: number, questionName: string, value: string) {    
    this.setTrackingHistory(questionId, questionName, value);
    this.shared.setListQuestionValue(this.section, questionId, questionName, value);    
    this.shared.updateCacheSection(this.section);
  }
  setTrackingHistory(questionId: number, questionName: string, value: string) {
    if (this.inaStatusTypeId == 2) {
      var tempTrackingHistory: TrackingHistory = this.shared.setTrackingHistory(this.section, questionId, questionName, value);
      this.updateHistory.emit(tempTrackingHistory);      
    }
  }

  get currentParent1(): any { return this.frmParentGuardian.get('currentParent1'); }
  get relationship1(): any { return this.frmParentGuardian.get('relationship1'); }
  get phone1(): any { return this.frmParentGuardian.get('phone1'); }
  get currentParent2(): any { return this.frmParentGuardian.get('currentParent2'); }
  get relationship2(): any { return this.frmParentGuardian.get('relationship2'); }
  get phone2(): any { return this.frmParentGuardian.get('phone2'); }

}
